var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoKeymasterBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-5.6%",
    y: "-50%",
    width: "111.7%",
    height: "210%",
    filterUnits: "objectBoundingBox",
    id: "ypkpywiuya"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.647058824 0 0 0 0 0.678431373 0 0 0 0 0.741176471 0 0 0 0.8 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "wn7k5f08ab"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.662745 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "",
    transform: "translate(-321 -4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M321.5 4h32v32h-32z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "",
    strokeLinejoin: "round",
    transform: "translate(321.5 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6 5.8C21.522 3.933 18.915 3 15.78 3c-3.03 0-5.583.95-7.662 2.853C6.04 7.755 5 10.168 5 13.092v6.816c0 2.959 1.075 5.38 3.223 7.265 2.148 1.885 4.949 2.827 8.4 2.827 3.453 0 6.271-1.056 8.455-3.17.493-.494.458-.969-.105-1.426l-4.65-3.33c-.353-.317-.74-.299-1.163.053-.81.634-1.656.951-2.536.951-2.077 0-3.185-.908-3.349-2.701-.012-.103-.03-.204-.03-.31l-.003-.159.002-.226v-2.996a4.08 4.08 0 1 1 5.195 0v2.429h7.326c.282 0 .51-.088.687-.264.175-.176.263-.406.263-.687v-5.072c.002-2.995-1.037-5.425-3.115-7.292z",
    stroke: "#00A9FD",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoKeymasterBlue);
export default __webpack_public_path__ + "static/media/PictoKeymasterBlue.ce5c3d636990f55fa654414d246f5c4a.svg";
export { ForwardRef as ReactComponent };